import React, { useCallback, useState } from 'react';
import Modal from '@reverbdotcom/commons/src/components/modal';
import { RCButton } from '@reverbdotcom/cadence/components';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import I18n from 'i18n-js';
import PayStatementContainer from './pay_statement_container';
import { StatementProps } from './pay_statement_form';
import AddNewCardContainer from './add_new_card_container';

interface ExternalProps {
  returnUrl: string;
}

type Props = ExternalProps & StatementProps;

function PayStatementModal({
  balanceCents,
  currencyCode,
  returnUrl,
  statementId,
  totalOwedCents,
  totalPaidCents,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [shouldDisplayAddNewCardForm, setShouldDisplayAddNewCardForm] = useState(false);
  const [newCardId, setNewCardId] = useState(null);

  const closeModal = useCallback(() => {
    setShouldDisplayAddNewCardForm(false);
    setIsOpen(false);
  }, [ setIsOpen, setShouldDisplayAddNewCardForm ]);

  const toggleDisplayNewCardForm = useCallback(() => {
    setShouldDisplayAddNewCardForm(!shouldDisplayAddNewCardForm);
  }, [ setShouldDisplayAddNewCardForm, shouldDisplayAddNewCardForm ]);

  const selectNewCreditCard = useCallback((creditCardId: string) => {
    toggleDisplayNewCardForm();
    setNewCardId(creditCardId);
  }, [ setNewCardId, toggleDisplayNewCardForm ]);

  return (
    <>
      <RCButton
        onClick={() => setIsOpen(!isOpen)}
        variant='primary'
        size='mini'
      >
        <Translate text='discovery.payStatement.payNowButtonText' />
      </RCButton>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        headerTitle={
          shouldDisplayAddNewCardForm ?
            I18n.t('discovery.payStatement.addNewCardModalTitle') :
            I18n.t('discovery.payStatement.payNowModalTitle')
        }
      >
        {shouldDisplayAddNewCardForm ? (
          <AddNewCardContainer
            toggleDisplayNewCardForm={toggleDisplayNewCardForm}
            returnUrl={returnUrl}
            selectNewCreditCard={selectNewCreditCard}
          />
        ) : (
          <PayStatementContainer
            balanceCents={balanceCents}
            closeModal={closeModal}
            currencyCode={currencyCode}
            newCardId={newCardId}
            statementId={statementId}
            totalOwedCents={totalOwedCents}
            totalPaidCents={totalPaidCents}
            toggleDisplayNewCardForm={toggleDisplayNewCardForm}
          />
        )}
      </Modal>
    </>
  );
}

export default PayStatementModal;
